import { type QueryOptions } from '@tanstack/query-core'

import { type MonthlyTourReportExEntity } from '@/libs/api'

import {
  type FetchMonthlyTourReportQuery,
  fetchMonthlyTourReport
} from '../api'
import { monthlyTourReportsQueryKeys } from '../query-keys'

/**
 * 月次支払レポート詳細のQueryOptionsを返す
 */
export const getMonthlyTourReportQueryOptions = (
  query: FetchMonthlyTourReportQuery
): Required<
  Pick<QueryOptions<MonthlyTourReportExEntity>, 'queryKey' | 'queryFn'>
> => {
  return {
    queryKey: monthlyTourReportsQueryKeys.detail(query),
    queryFn: async ({ signal }) => fetchMonthlyTourReport(query, signal)
  }
}
